import { render } from "./rep160.vue?vue&type=template&id=6f0c7715"
import script from "./rep160.vue?vue&type=script&lang=js"
export * from "./rep160.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__